var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.22 0.21934C10.3606 0.0788894 10.5512 0 10.75 0C10.9488 0 11.1394 0.0788894 11.28 0.21934L17.28 6.21934C17.4205 6.35997 17.4993 6.55059 17.4993 6.74934C17.4993 6.94809 17.4205 7.13871 17.28 7.27934L11.28 13.2793C11.2113 13.353 11.1285 13.4121 11.0365 13.4531C10.9445 13.4941 10.8452 13.5162 10.7445 13.5179C10.6438 13.5197 10.5438 13.5012 10.4504 13.4635C10.357 13.4257 10.2722 13.3696 10.201 13.2984C10.1297 13.2272 10.0736 13.1423 10.0359 13.0489C9.99816 12.9555 9.97963 12.8555 9.98141 12.7548C9.98318 12.6541 10.0052 12.5548 10.0462 12.4628C10.0872 12.3708 10.1463 12.288 10.22 12.2193L14.94 7.49934H0.75C0.551088 7.49934 0.360322 7.42032 0.21967 7.27967C0.0790175 7.13902 0 6.94825 0 6.74934C0 6.55043 0.0790175 6.35966 0.21967 6.21901C0.360322 6.07836 0.551088 5.99934 0.75 5.99934H14.94L10.22 1.27934C10.0795 1.13871 10.0007 0.948091 10.0007 0.74934C10.0007 0.550589 10.0795 0.359965 10.22 0.21934Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorRight);
export default __webpack_public_path__ + "static/media/Vector_right.38d752ff3fa10ee81cd2ac01717a8565.svg";
export { ForwardRef as ReactComponent };